import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { Text } from '../components';

const containerBaseStyles = ({ theme }) => css`
  padding: 0 ${theme.spacings.exa};
`;

const Container = styled('div')(containerBaseStyles);

const textContainerBaseStyles = ({ theme }) => css`
  color: ${theme.colors.b500};
  text-align: center;
`;

const textContainerMarginStyles = ({ margin }) =>
  margin &&
  css`
    margin-top: 0;
    margin-bottom: 0;
  `;

const TextContainer = styled('div')(textContainerBaseStyles, textContainerMarginStyles);

const titleOverrideBaseStyles = () => css`
  p {
    line-height: 22px !important;
  }
`;

const TitleOverride = styled('div')(titleOverrideBaseStyles);

const textOverrideBaseStyles = () => css`
  p {
    line-height: 19px !important;
  }
`;

const TextOverride = styled('div')(textOverrideBaseStyles);

const QuizHeader = ({ title, text }) => (
  <Container>
    <TextContainer>
      <TitleOverride>
        <Text size='zetta' bold>
          {title}
        </Text>
      </TitleOverride>
      {text && (
        <TextContainer margin>
          <TextOverride>
            <Text size='giga'>{text}</Text>
          </TextOverride>
        </TextContainer>
      )}
    </TextContainer>
  </Container>
);

QuizHeader.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
};

QuizHeader.defaultProps = {
  title: 'Please solve the math problem below to continue',
};

export default QuizHeader;
